import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface Condition {
  type: "operand" | "operator";
  id: string;
  label?: string;
  operator?: string;
  questionType?: string;
  value?: string | number;
  tolerance?: number;
  choices?: { id: string; label: string; ref: string }[];
}

export interface CohortSlice {
  conditions: Condition[];
}

const initialState: CohortSlice = {
  conditions: [],
};

export const cohortSlice = createSlice({
  name: "cohort",
  initialState: initialState,
  reducers: {
    modifyCohortValue: (
      state,
      action: PayloadAction<{
        key: keyof Condition;
        value: any;
        index: number;
      }>
    ) => {
      const condition = state.conditions[action.payload.index];
      if (condition) {
        (condition[action.payload.key] as any) = action.payload.value;
      }
    },
    addCohortCondition: (
      state,
      action: PayloadAction<{
        index?: number;
        newCondition: Condition;
      }>
    ) => {
      if (typeof action.payload.index !== "undefined") {
        state.conditions.splice(
          action.payload.index,
          0,
          action.payload.newCondition
        );
      } else {
        state.conditions.push(action.payload.newCondition);
      }
    },
    removeCohortCondition: (
      state,
      action: PayloadAction<{ index: number }>
    ) => {
      state.conditions.splice(action.payload.index, 1);
    },
    moveCohortCondition: (
      state,
      action: PayloadAction<{ sourceIndex: number; destinationIndex: number }>
    ) => {
      const condition = state.conditions[action.payload.sourceIndex];
      state.conditions.splice(action.payload.sourceIndex, 1);
      state.conditions.splice(action.payload.destinationIndex, 0, condition);
    },
  },
});

export const {
  modifyCohortValue,
  addCohortCondition,
  removeCohortCondition,
  moveCohortCondition,
} = cohortSlice.actions;

export default cohortSlice.reducer;
